import script from "./UWidgetHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./UWidgetHeader.vue?vue&type=script&setup=true&lang=ts"

import "./UWidgetHeader.vue?vue&type=style&index=0&id=20eb67f2&lang=css"

const __exports__ = script;

export default __exports__